import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import CitiesIndex from "@/pages/CitiesIndex";
import CityPage from "@/pages/CityPage";
import ComboPage from "@/pages/ComboPage";
import SitemapPage from "@/pages/SitemapPage";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightArticle from "@/pages/InsightArticle";
import CountyPage from "@/pages/CountyPage";
import Careers from "@/pages/Careers";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:serviceSlug" element={<ServicePage />} />
            <Route path="/services/:serviceSlug/:citySlug" element={<ComboPage />} />
            <Route path="/cities" element={<CitiesIndex />} />
            <Route path="/cities/:citySlug" element={<CityPage />} />
            <Route path="/counties/:countySlug" element={<CountyPage />} />
            <Route path="/insights" element={<InsightsIndex />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
